const CustomerLangs = {
  customerList: {
    title: "Danh sách khách hàng",
  },
};
export default CustomerLangs;
